<div class="w-100 h-100">
    <div class="d-flex justify-content-center">
        <div class="box pb-3">
            <div class="card-box bg-blue" :class="{'active': requestStatusBox.includes('0') || requestStatusBox.length === 0 }" @click="filter('0')">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{$t('dashboardPage.all')}}<br /> {{$t('dashboardPage.requests')}}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{dashboardBoxes.all}}</h2>
                    </div>
                </div>
            </div>
        </div>  
        <div class="box pb-3">
            <div class="card-box bg-pink" :class="{'active': requestStatusBox.includes('1')}" @click="filter('1')">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{$t('dashboardPage.pendingFor')}} <br /> {{$t('dashboardPage.approval')}}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{dashboardBoxes.pendingForApproval}}</h2>
                    </div>
                </div>
                <div class="card-box-footer">{{dashboardBoxes.pendingForApprovalPercentage}}% {{$t('dashboardPage.thisMonth')}}</div>
            </div>
        </div>
        <div class="box pb-3">
            <div class="card-box bg-green" :class="{'active': requestStatusBox.includes('2')}" @click="filter('2')">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{$t('dashboardPage.approved')}} <br /> {{$t('dashboardPage.requests')}}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{dashboardBoxes.approved}}</h2>
                    </div>
                </div>
                <div class="card-box-footer">{{dashboardBoxes.approvedPercentage}}% {{$t('dashboardPage.thisMonth')}}</div>
            </div>
        </div>
        <div class="box pb-3">
            <div class="card-box bg-red" :class="{'active': requestStatusBox.includes('3')}" @click="filter('3')">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{$t('dashboardPage.rejected')}} <br /> {{$t('dashboardPage.requests')}}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{dashboardBoxes.rejected}}</h2>
                    </div>
                </div>
                <div class="card-box-footer">{{dashboardBoxes.rejectedPercentage}}% {{$t('dashboardPage.thisMonth')}}</div>
            </div>
        </div>
        <div class="box pb-3">
            <div class="card-box bg-gray" :class="{'active': requestStatusBox.includes('4')}" @click="filter('4')">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{$t('dashboardPage.paid')}} <br /> {{$t('dashboardPage.requests')}}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{dashboardBoxes.paid}}</h2>
                    </div>
                </div>
                <div class="card-box-footer">{{dashboardBoxes.paidPercentage}}% {{$t('dashboardPage.thisMonth')}}</div>
            </div>
        </div>
        <div class="box pb-3">
            <div class="card-box bg-dark-blue" :class="{'active': requestStatusBox.includes('5')}" @click="filter('5')">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{$t('dashboardPage.expired')}} <br /> {{$t('dashboardPage.requests')}}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{dashboardBoxes.expired}}</h2>
                    </div>
                </div>
                <div class="card-box-footer">&nbsp;</div>
            </div>
        </div>
    </div>
    <div class="row row-table">
        <div class="col-md-12">
            <div class="card card_layout">
                <div class="card-header">
                    <div class="form-row justify-content-between align-items-center w-100">
                        <div class="col-auto">
                            <label class="card_header_text">
                                <i class="fas fa-sync-alt reload" @click="reload()"></i>
                                {{$t('dashboardPage.requests')}} ({{sendersCount}})
                            </label>
                        </div>
                        <div class="col-auto">
                            <button v-if="userRole == 2 || userRole == 5 || isCstReadOnly" class="btn btn-primary btn-action" @click="exportToExcel()">{{$t('dashboardPage.exportRequestsToExcel')}}</button>
                            <button v-if="((userRole == 2 || userRole == 5) && !providerLocked && !providerExpired  && !providerDissconected)" :disabled="!isAnySelected" class="btn btn-primary btn-action" @click="showresendDialog('')">{{$t('dashboardPage.resend')}}</button>
                            <button v-if="contractOptions.isRenewContractEnabled && (userRole == 2 || userRole == 5) && !providerDissconected" class="btn btn-primary btn-action" @click="checkRenewContract()">{{$t('dashboardPage.renew')}}</button>
                            <button v-if="((userRole == 2 || userRole == 5) && !providerLocked && contractOptions.isNewContractEnabled && !providerExpired && !providerDissconected)" @click="addRequest()" tag="button" class="btn btn-primary btn-action">{{$t('dashboardPage.newRequest')}} <i class="fas fa-plus px-2"></i></button>
                            <button v-if="userRole == 1 || userRole == 9 || userRole == 15" :disabled="!isAnySelected" class="btn btn-primary btn-action" @click="showapproveDialog('')">{{$t('dashboardPage.Approve')}}</button>
                            <button v-if="userRole == 1 || userRole == 9 || userRole == 15" :disabled="!isAnySelected" class="btn btn-primary btn-action" @click="showRejectDialog()">{{$t('dashboardPage.reject')}}</button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="form-row align-items-start w-100">
                        <div class="col">
                            <div class="form-row flex-md-nowrap">
                                <div class="col">
                                    <div class="input-group mb-3">
                                        <input class="form-control border-right-0 border-left"
                                               type="text"
                                               v-model="filterModel.displayId"
                                               @input="onInputSearch"
                                               :placeholder="$t('dashboardPage.displayId')" />
                                        <div class="input-group-append">
                                            <span class="input-group-text right gray">
                                                <i class="fas fa-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="input-group mb-3">
                                        <input class="form-control border-right-0 border-left"
                                               type="text"
                                               v-model="filterModel.senderName"
                                               @input="onInputSearch"
                                               :placeholder="$t('dashboardPage.senderNameSearch')" />
                                        <div class="input-group-append">
                                            <span class="input-group-text right gray">
                                                <i class="fas fa-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="input-group mb-3">
                                        <input class="form-control border-right-0 border-left"
                                               type="text"
                                               @input="onInputSearch"
                                               v-model="filterModel.clientName"
                                               :placeholder="$t('dashboardPage.clientName')" />
                                        <div class="input-group-append">
                                            <span class="input-group-text right gray">
                                                <i class="fas fa-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col" v-if="userRole != 2 && userRole != 5">
                                    <div class="input-group mb-3">
                                        <input class="form-control border-right-0 border-left"
                                               type="text"
                                               @input="onInputSearch"
                                               v-model="filterModel.providerName"
                                               :placeholder="$t('dashboardPage.providerName')" />
                                        <div class="input-group-append">
                                            <span class="input-group-text right gray">
                                                <i class="fas fa-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col" v-if="userRole == 2 || userRole == 5">
                                    <div class="input-group mb-3">
                                        <v-select :items="requestsDateExpiryOptions"
                                                  v-model="requestsFilterExpiryOption"
                                                  item-text="name"
                                                  item-value="id"
                                                  :label="$t('shortPage.remaningDays')"
                                                  solo attach>
                                        </v-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-auto mb-3" v-if="userRole == 9 || userRole == 1 || userRole == 3 || userRole == 4 || userRole == 15 || userRole == 2 || userRole == 5">
                            <button @click="reset" class="btn btn-primary btn-action">{{$t('shared.reset')}}</button>
                        </div>
                    </div>
                    <div class="form-row align-items-start w-100" v-if="userRole == 2 || userRole == 5">
                        <div class="col">
                            <div class="form-row flex-md-nowrap">
                                <div class="col">
                                    <div class="input-group mb-3">
                                        <v-select :items="contractDateRequestExpiryOptions"
                                                  v-model="contractFilterExpiryOption"
                                                  item-text="name"
                                                  item-value="id"
                                                  :label="$t('shortPage.contractExpiryDate')"
                                                  solo attach>
                                        </v-select>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="input-group mb-3">
                                        <v-select :items="contractDateRequestOptions"
                                                  v-model="contractFilterOption"
                                                  item-text="name"
                                                  item-value="id"
                                                  :label="$t('dashboardPage.displayContracts')"
                                                  solo attach>
                                        </v-select>
                                    </div>
                                </div>
                                <div class="col mb-4">
                                    <div class="input-group mb-3">
                                        <v-menu v-model="createdDateFromMenu"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                lazy
                                                full-width
                                                min-width="290px"
                                                offset-y attach>
                                            <template v-slot:activator="{ on }">
                                                <div class="input-group">
                                                    <input class="form-control border-right-0 border-left"
                                                           v-model="filterModel.createdDateFrom"
                                                           :placeholder="$t('shared.createdDateFrom')"
                                                           readonly
                                                           :clearable="true"
                                                           ref="createdDatePicker" v-on="on" type="text" />
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text right gray">
                                                            <i class="far fa-calendar-alt"></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </template>
                                            <v-date-picker v-model="filterModel.createdDateFrom"
                                                           no-title
                                                           scrollable
                                                           @input="onDateChange('from')">
                                            </v-date-picker>
                                        </v-menu>
                                    </div>
                                </div>
                                <div class="col mb-3">
                                    <div class="input-group mb-3">
                                        <v-menu v-model="createdDateToMenu"
                                                :close-on-content-click="false"
                                                lazy
                                                full-width
                                                :nudge-right="40"
                                                min-width="290px"
                                                transition="scale-transition" offset-y attach>
                                            <template v-slot:activator="{ on, attrs }">
                                                <div class="input-group mb-3">
                                                    <input class="form-control border-right-0 border-left"
                                                           v-model="filterModel.createdDateTo"
                                                           :placeholder="$t('shared.createdDateTo')"
                                                           readonly v-bind="attrs"
                                                           ref="createdDatePicker" v-on="on" type="text" />
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text right gray">
                                                            <i class="far fa-calendar-alt"></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </template>
                                            <v-date-picker v-model="filterModel.createdDateTo" no-title scrollable
                                                           @input="onDateChange('to')">
                                            </v-date-picker>
                                        </v-menu>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-auto mb-3">
                            <button class="btn btn-primary btn-action invisible" tabindex="-1" aria-hidden="true">{{$t('shared.reset')}}</button>
                        </div>
                    </div>
                    <template>
                        <v-data-table v-model="selected"
                                      :headers="headers"
                                      :items="senders"
                                      :total-items="sendersCount"
                                      select-all
                                      :pagination.sync="pagination"
                                      @update:pagination="updatePaginate"
                                      :rows-per-page-text="$t('shared.rowsPerPage')"
                                      :rows-per-page-items='[10, 25, 50, 100]'
                                      item-key="requestId"
                                      class="elevation-1 table-striped">
                            <template v-slot:headers="props">
                                <tr>
                                    <th v-if="!isCstReadOnly">
                                        <v-checkbox :input-value="props.all"
                                                    :indeterminate="props.indeterminate"
                                                    primary
                                                    hide-details
                                                    @click.stop="selectAll"></v-checkbox>
                                    </th>
                                    <th v-for="header in props.headers"
                                        :key="header.text"
                                        :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                                        @click="changeSort(header.value)" :width="header.width !== ''? header.width : ''">
                                        <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
                                        {{ header.text }}
                                    </th>
                                </tr>
                            </template>
                            <template v-slot:items="props">
                                <tr>
                                    <td v-if="!isCstReadOnly">
                                        <v-checkbox v-model="props.selected"
                                                    @change="select($event, props.item.id)"
                                                    primary
                                                    hide-details></v-checkbox>
                                    </td>
                                    <td class="text-center">{{props.item.displayId}}</td>
                                    <td class="text-center">{{props.item.senderName}}</td>
                                  <td class="text-center">
                                        <v-icon v-if="props.item.isClientFavorite && (userRole == 2 || userRole == 5)"
                                                :style="{color: favoriteIconColor, fontSize: '20px' }">
                                            mdi-star-circle-outline
                                        </v-icon>
                                        {{ props.item.clientName }}
                                    </td>
                                    <td class="text-center">{{ props.item.providerName }}</td>
                                    <td class="text-center">{{ props.item.createdDate }}</td>
                                    <td class="text-center">{{ props.item.expiryDate }}</td>
                                    <td class="text-center" width="100px">
                                        <div class="d-flex justify-content-center align-items-center operator-status-row">
                                            <div v-for="op in getPrimaryOperators()" :key="'primary-' + op.id" class="operator-status-icon">
                                                <div class="operator-brand-circle" :class="getOperatorBrandClass(op.name)">
                                                    <img v-if="hasOperatorIcon(op.name)" :src="getOperatorIconSrc(op.name)" :alt="op.name" />
                                                    <span v-else class="operator-fallback-icon">{{ getOperatorInitial(op.name) }}</span>
                                                </div>
                                                <span class="operator-status-dot" :class="isOperatorActive(props.item, op.name) ? 'operator-status-dot--active' : 'operator-status-dot--inactive'"></span>
                                            </div>
                                            <v-menu v-if="getOverflowOperators().length > 0"
                                                    :value="moreOperatorsMenuId === props.item.id"
                                                    @input="onMoreOperatorsMenuInput($event, props.item.id)"
                                                    offset-y
                                                    :close-on-content-click="false"
                                                    content-class="operator-more-menu">
                                                <template v-slot:activator="{ on }">
                                                    <div class="operator-overflow-badge" v-on="on">
                                                        +{{ getOverflowOperators().length }}
                                                    </div>
                                                </template>
                                                <v-card>
                                                    <v-card-title class="operator-more-menu__title py-2 px-3">
                                                        <span>{{ $t('dashboardPage.moreOperators') }}</span>
                                                        <i class="fas fa-times operator-more-menu__close" @click="closeMoreOperatorsMenu"></i>
                                                    </v-card-title>
                                                    <v-card-text class="operator-more-menu__body py-2 px-3">
                                                        <div v-for="op in getOverflowOperators()" :key="'overflow-' + op.id" class="operator-more-menu__item">
                                                            <div class="operator-status-icon">
                                                                <div class="operator-brand-circle" :class="getOperatorBrandClass(op.name)">
                                                                    <img v-if="hasOperatorIcon(op.name)" :src="getOperatorIconSrc(op.name)" :alt="op.name" />
                                                                    <span v-else class="operator-fallback-icon">{{ getOperatorInitial(op.name) }}</span>
                                                                </div>
                                                                <span class="operator-status-dot" :class="isOperatorActive(props.item, op.name) ? 'operator-status-dot--active' : 'operator-status-dot--inactive'"></span>
                                                            </div>
                                                            <span class="operator-more-menu__name">{{ op.name }}</span>
                                                        </div>
                                                    </v-card-text>
                                                </v-card>
                                            </v-menu>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <div class="status_txt" :class="'status-' + props.item.requestStatus">{{GetSenderStatus(props.item.requestStatus)}}</div>
                                            <Progress :transitionDuration="1000" :radius="10" :strokeColor="checkColor(props.item.requestStatus)" :strokeWidth="5" :value="getRate(props.item.remainingDays,props.item.totalDays)">
                                                <div class="content"></div>
                                                <template v-slot:footer>
                                                    <b></b>
                                                </template>
                                            </Progress>
                                            <div class="days_left">
                                                {{props.item.remainingDays}} {{$t('dashboardPage.of')}} {{props.item.totalDays}} <br /> {{$t('dashboardPage.daysLeft')}}
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-center">{{ props.item.senderExpiryDate }}</td>
                                    <td class="text-center btn_menu">
                                        <template>
                                            <v-menu offset-y open-on-hover>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn :class="{
                                                          'btn-disabled-design': ((userRole == 1 || userRole == 9 || userRole == 15) &&
                                                                         (props.item.requestStatus != '4' && props.item.requestStatus != '5') &&
                                                                         props.item.automaticallyInserted)
                                                        }"
                                                           color="btn-primary"
                                                           v-on="on">
                                                        <div>{{$t('shared.actions')}}</div>
                                                        <i class="fas fa-chevron-down pl-4" style="vertical-align: sub;"></i>
                                                    </v-btn>
                                                </template>
                                                <v-list>
                                                    <div v-if="!isCstReadOnly && !((userRole == 1 || userRole == 2 || userRole == 5 || userRole == 9 || userRole == 15) && (props.item.requestStatus != '4' && props.item.requestStatus != '5') && props.item.automaticallyInserted)">
                                                        <v-list-tile v-if="(userRole == 1  || userRole == 9 || userRole == 15) && props.item.requestStatus == '1' && !props.item.automaticallyInserted && ((userRole == 1 && props.item.tenantId == tenantId) || userRole != 1) " @click="showapproveDialog(props.item.id)">
                                                            <v-list-tile-title class="white">{{$t('dashboardPage.Approve')}}</v-list-tile-title>
                                                        </v-list-tile>
                                                        <v-list-tile v-if="( ([1,9,15].includes(userRole) &&
                                                                     ((userRole == 1 && props.item.tenantId == tenantId) || userRole != 1))
                                                                     ||  ([2,5].includes(userRole) &&
                                                                     !props.item.providerRejected &&
                                                                     isWithinTwoHours(props.item.createdDateTime)))
                                                                     && props.item.requestStatus === 1
                                                                     && !props.item.automaticallyInserted"
                                                                     @click="showRejectDialog(props.item)">

                                                            <v-list-tile-title class="white">{{$t('dashboardPage.reject')}}</v-list-tile-title>
                                                        </v-list-tile>
                                                        <v-list-tile v-if="(userRole == 2 || userRole == 5) && !providerLocked && !providerExpired && !providerDissconected && props.item.requestStatus == '3' && !props.item.automaticallyInserted" @click="showresendDialog(props.item.id)">
                                                            <v-list-tile-title class="white">{{$t('dashboardPage.resend')}}</v-list-tile-title>
                                                        </v-list-tile>
                                                        <v-list-tile v-if="(userRole == 2 || userRole == 5) && props.item.requestStatus == '3'&& !props.item.automaticallyInserted"
                                                                     :to="'/ConnectingRequestDashboard/UpdateContractRequest/' +  props.item.id">
                                                            <v-list-tile-title class="white">{{$t('shared.edit')}}</v-list-tile-title>
                                                        </v-list-tile>
                                                        <v-list-tile v-if="contractOptions.isRenewContractEnabled &&(userRole == 2 || userRole == 5) && !providerExpired && !providerDissconected &&  ((props.item.requestStatus == '5' && props.item.senderStatus != 6) || (props.item.requestStatus == '4' ))"
                                                                     @click="checkRenewContractRow(props.item.id)">
                                                            <v-list-tile-title class="white">        {{$t('dashboardPage.renewContract')}}</v-list-tile-title>
                                                        </v-list-tile>
                                                        <v-list-tile v-if="contractOptions.isExtendSenderDurationEnabled &&(userRole == 2 || userRole == 5) && !providerExpired && !providerDissconected &&  (props.item.requestStatus == '5'|| props.item.requestStatus == '4')&&(props.item.senderStatus == 5||props.item.senderStatus == 7)"
                                                                     @click="checkRenewSender(props.item.senderId)">
                                                            <v-list-tile-title class="white"> {{$t('dashboardPage.extendSenderDuration')}}</v-list-tile-title>
                                                        </v-list-tile>
                                                        <v-list-tile v-if="(userRole == 2 || userRole == 5 )&& props.item.requestStatus == '4' && props.item.senderStatus == 7" @click="ConectivityDetail(props.item.senderId)">
                                                            <v-list-tile-title class="white">{{$t('dashboardPage.ConnectivityDetail')}}</v-list-tile-title>
                                                        </v-list-tile>
                                                        <v-list-tile v-if="((userRole == 2 || userRole == 5 ) && props.item.requestStatus == '4' && (props.item.senderStatus == '2' || (props.item.senderStatus == '7')))" @click="ChangeSenderType(props.item.id)">
                                                            <v-list-tile-title class="white">{{$t('shared.changeSenderType')}}</v-list-tile-title>
                                                        </v-list-tile>
                                                    </div>
                                                    <v-list-tile @click="Details(props.item.id)">
                                                        <v-list-tile-title class="white">{{$t('dashboardPage.details')}}</v-list-tile-title>
                                                    </v-list-tile>
                                                      <v-list-tile v-if="(userRole == 2 || userRole == 5) && !props.item.isClientFavorite " @click="showFavoriteDialog(props.item.senderId)">
                                                        <v-list-tile-title class="white">{{$t('shared.favorite')}}</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile v-if="(userRole == 2 || userRole == 5) && props.item.isClientFavorite " @click="showUnfavoriteDialog(props.item.senderId)">
                                                        <v-list-tile-title class="white">{{$t('shared.unfavorite')}}</v-list-tile-title>
                                                    </v-list-tile>
                                                </v-list>
                                            </v-menu>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </template>
                </div>
            </div>
        </div>
    </div>
        <div class="text-xs-center">
        <v-dialog v-model="favoriteDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.favorite')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideFavoriteDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text>
                    <p class="mt-3">
                        {{$t('shared.favoriteInputText')}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideFavoriteDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="favorClient()">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="unfavoriteDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.unfavorite')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideUnfavoriteDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text>
                    <p class="mt-3">
                        {{$t('shared.unfavoriteInputText')}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideUnfavoriteDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="unfavorClient()">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="resendDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.resendInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideresendDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text>
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>{{$t('dashboardPage.comment')}}</label>
                                <input v-model="resendComment" class="form-control " type="text" />
                            </div>
                        </div>
                    </div>
                    <p class="mt-3">
                        {{$t('shared.resendContractInputText')}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideresendDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="resend('')">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="approveDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.approveInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideapproveDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text-center">
                    <p class="mt-3">
                        {{$t('shared.approveContractInputText')}}
                    </p>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideapproveDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="approve('')">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

    <div class="text-xs-center">
        <v-dialog v-model="deleteDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.deleteInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideDeleteDialog"></i>
                    </div>
                </v-card-title>

                <v-card-text class="text">
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>{{$t('dashboardPage.comment')}}</label>
                                <input v-model="deleteComment" class="form-control " type="text" />
                            </div>
                        </div>
                    </div>
                    <p class="mt-3">
                        {{$t('shared.deletesenderInputText')}}
                    </p>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideDeleteDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="deleteSender">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="rejectdialog" persistent width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('dashboardPage.reject')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideRejectDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text>

                    <div class="row mt-3">
                        
                        <div class="col-md-12">
                            <reject-reason-multi-select
                                :items="popUpRejectionReasons"
                                :value="selectedRejectReasons"
                                :other-text="otherRejectReasonText"
                                :disabled="rejectReasonsLocked"
                                @input="onRejectReasonsChanged"
                                @other-text="onOtherRejectTextChanged">
                            </reject-reason-multi-select>
                        </div>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideRejectDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" :disabled="!rejectReasonIsValid" @click="reject">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

</div>

